import React from "react";
export const ScaleContext = React.createContext();
